import { gql } from '@apollo/client';

export const UPDATE_CONFIGURATION = gql`
  mutation updateConfigurationMutation($language: String!, $configuration: JSON!) {
    updateConfiguration(language: $language, configuration: $configuration)
  }
`;
